'use client';

import { Search } from 'lucide-react';
import Form from 'next/form';
import { FormEvent, RefObject, useState } from 'react';

import Popover from '@/globals/Header/components/Popover/index';
import { pseudoI18n } from '@/i18n/pseudoI18n';
import { PATHS } from '@/constants/paths';

export default function DHeaderSearch(props: { ref: RefObject<HTMLFormElement | null> }) {
  const { ref } = props;

  const { t } = pseudoI18n();

  const [searchQuery, setSearchQuery] = useState<string>('');
  const [showNotices, setShowNotices] = useState<boolean>(false);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    if (searchQuery.trim().length < 2) {
      e?.preventDefault();
      setShowNotices(true);
    }
  };

  return (
    <Form action={PATHS.SEARCH} ref={ref} className="relative ml-2.5" onSubmit={handleSubmit}>
      <label htmlFor="header-search" className="relative">
        <span className="w-0 hidden invisible opacity-0">{t('Search')}</span>
        <input
          id="header-search"
          name="q"
          placeholder={t('Search')}
          onChange={(e) => setSearchQuery(e.target.value)}
          value={searchQuery}
          className="bg-neutral-100 border border-neutral-300 py-2.5 pl-3 pr-10 rounded-lg w-40 placeholder-neutral-1000 text-sm"
        />

        <button aria-label={t('Search')} className="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer p-2" type="submit">
          <Search width={20} />
        </button>
      </label>
      <Popover
        showNotices={showNotices}
        setShowNotices={setShowNotices}
        content={t('Please enter at least 2 characters.')}
      />
    </Form>
  );
}
